/* RESPONSIBLE TEAM: team-self-serve */
import Route from '@ember/routing/route';
import { get } from 'embercom/lib/ajax';
import { captureException } from 'embercom/lib/sentry';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

export default class Referrals extends Route {
  @service declare appService: any;
  @service declare router: any;
  @service declare intl: IntlService;

  get titleToken() {
    return this.intl.t(`new-settings.submenu.workspace.referrals`);
  }

  beforeModel() {
    if (!this.appService.app.canUseReferrals) {
      this.router.transitionTo('apps.app.index');
    }
  }

  async model() {
    let referral;
    try {
      referral = await get(
        `/ember/referrals?app_id=${this.appService.app.id}&admin_id=${this.appService.app.currentAdmin.id}`,
      );
    } catch (error) {
      captureException(new Error('Referrals get failed'), {
        fingerprint: ['referrals'],
        tags: {
          responsibleTeam: 'team-self-serve',
          responsible_team: 'team-self-serve',
        },
      });
    }
    return referral.code;
  }
}
